import type { Rule } from "../types";

const EVIDENCE = "sniderman_2019_apob_primary";

/**
 * Stubbed for v1: same reasoning as `vit_d_recheck_due` — fires once
 * `RuleContext` includes biomarker history. ApoB > 80 mg/dL is the threshold
 * (Sniderman 2019).
 */
export const apobAboveTarget: Rule = {
  id: "apob_above_target",
  domain: "health.body",
  topics: ["apob", "lipid_panel", "cardiovascular_risk"],
  evidence_refs: [EVIDENCE],
  title: () => "ApoB above target",
  evaluate() {
    return null;
  },
};
